import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js/number/max-safe-integer";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import EmailEditor from "@Shared/components/inputs/email-editor";
import Dropdown from "../dropdown.vue";
import { isEmpty, isEqual, random } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailArgument",
  components: {
    Fragment,
    EmailEditor,
    Dropdown
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        subject: "",
        body: ""
      })
    },
    emailSynced: {
      type: Boolean,
      default: true
    },
    emailSignature: {
      type: String,
      default: ""
    },
    owner: {
      type: Object,
      default: () => ({})
    },
    editing: {
      type: Boolean,
      default: false
    },
    referrerEmail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const body = isEmpty(this.value.body) ? `<br> -- <br> ${this.emailSignature}` : this.value.body;
    return {
      email: {
        subject: this.value.subject,
        body,
        coapplicantOption: this.value.coapplicantOption || null
      },
      editor: {},
      editorId: random(1, _Number$MAX_SAFE_INTEGER),
      editorInstance: null
    };
  },
  computed: {
    coapplicantOptions() {
      return [{
        name: this.$t("automations.ccAllCoApplicants"),
        value: "CC_ALL"
      }, {
        name: this.$t("automations.sendSeparateEmailForCoApplicants"),
        value: "SEND_AS_SEPARATE"
      }, {
        name: this.$t("automations.dontSendToCoApplicants"),
        value: "IGNORE"
      }];
    },
    clientTags() {
      return [{
        tag: "{{FIRST_NAME}}",
        description: this.$t("application-form.first-name")
      }, {
        tag: "{{LAST_NAME}}",
        description: this.$t("application-form.last-name")
      }];
    },
    referrerTags() {
      return [{
        tag: "{{REF_FIRST_NAME}}",
        description: this.$t("application-form.referrer-first-name")
      }, {
        tag: "{{REF_LAST_NAME}}",
        description: this.$t("application-form.referrer-last-name")
      }];
    }
  },
  watch: {
    value() {
      if (!isEqual(this.email, this.value)) {
        this.email = _objectSpread({}, this.value);
        if (this.email.body !== this.$refs.emailEditor.getBody()) {
          this.$refs.emailEditor.setHtml(this.value.body);
        }
      }
    },
    "email.subject"() {
      this.handleChange();
    },
    "email.coapplicantOption"() {
      this.handleChange();
    }
  },
  mounted() {
    this.bindEmailEvents();
  },
  beforeDestroy() {
    this.unbindEmailEvents();
  },
  methods: {
    handleEditorChange({
      content
    }) {
      this.email.body = content;
      this.handleChange();
    },
    handleTag(tag) {
      this.$refs.emailEditor.insertText(tag);
    },
    handleChange() {
      this.$emit("input", _objectSpread({}, this.email));
    },
    goToSettings() {
      window.location.hash = "/personal-settings/account/email-preferences";
    },
    clear() {
      this.$refs.emailEditor.clearTemplate();
    },
    setHtml(html) {
      this.$refs.emailEditor.setHtml(html);
    },
    bindEmailEvents() {
      this.unbindEmailEvents();
      this.$root.$on("emailArgument::clearHtml", this.clear);
      this.$root.$on("emailArgument::setHtml", this.setHtml);
    },
    unbindEmailEvents() {
      this.$root.$off("emailArgument::clearHtml", this.clear);
      this.$root.$off("emailArgument::setHtml", this.setHtml);
    }
  }
});